export type ColorShades = {
    [key in '0' | '10' | '20' | '30' | '40' | '50' | '60' | '70' | '80' | '90' | '100']?: string;
};

type Colors = {
    [key: string]: ColorShades;
};

type TypographySize = {
    fontSize?: number | string;
    lineHeight?: number | string;
    letterSpacing?: number | string;
    fontWeight?: number | string;
    fontSizeXl?: number;
    lineHeightXl?: number;
};

export interface PaletteCategory {
    main?: string;
    onMain?: string;
    mainContainer?: string;
    mainFixed?: string;
    mainFixedDim?: string;
    mainVariant?: string;
    onMainFixed?: string;
    onMainFixedVariant?: string;
    outline?: string;
    outlineVariant?: string;
    onOutline?: string;
    surface?: string;
    surfaceContainerHighest?: string;
    onSurface?: string;
    onSurfaceVariant?: string;
    surfaceVariant?: string;
    font?: string;
    fontStyle?: TypographySize;
    variant?: string;
}

export interface CorePalette {
    primary?: PaletteCategory;

    [key: string]: PaletteCategory | undefined;
}

type TypographyFontProps = {
    [key: string]: {
        fontFamily?: string;
        fontWeight?: number;
        source?: Array<string>;
    };
};
export type ThemeTypography = {
    fonts: {
        [key: string]: TypographyFontProps;
    };
};
type Styles = {
    [key: string]: unknown;
};
export type ThemeStyles = {
    [key: string]: Styles;
};

export type Theme = {
    name?: string;
    themeName?: string;
    isDefault?: boolean;
    themeHash?: string;
    themeLink?: string | Pick<Theme, 'colors' | 'styles' | 'palette' | 'typography'>;
    colors?: Colors;
    palette?: {
        light: CorePalette;
        dark: CorePalette;
    };
    typography?: ThemeTypography;
    styles?: ThemeStyles;
};

export enum DefaultTheme {
    light = 'light',
    dark = 'dark',
    system = 'system',
}

export type Themes = Theme[];
